// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@primary-color: #1890ff;
@layout-header-background: #fff;
@layout-sider-background: #001529;
@menu-dark-bg: @layout-sider-background;
@menu-dark-item-active-bg: @primary-color;

@layout-header-height: 64px;
@layout-header-padding: 0 24px;
@layout-trigger-height: 48px;`, "",{"version":3,"sources":["webpack://./src/styles/antd.overrides.less.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB,+BAA+B;AAC/B,iCAAiC;AACjC,uCAAuC;AACvC,yCAAyC;;AAEzC,2BAA2B;AAC3B,8BAA8B;AAC9B,4BAA4B","sourcesContent":["@primary-color: #1890ff;\n@layout-header-background: #fff;\n@layout-sider-background: #001529;\n@menu-dark-bg: @layout-sider-background;\n@menu-dark-item-active-bg: @primary-color;\n\n@layout-header-height: 64px;\n@layout-header-padding: 0 24px;\n@layout-trigger-height: 48px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
